export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رسالة قصيرة"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تلقي رمز التحقق عبر رسالة نصية قصيرة"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["احصل على رمز التحقق عبر تطبيق التحقق"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قم بزيادة الأمان باستخدام المصادقة متعددة العوامل عند تسجيل الدخول."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التفعيل"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التفعيل"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مصادقة متعددة العوامل"])}
        }
      },
      "ar-DZ": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["استلام رمز التوثيق عبر الرسائل القصيرة"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["احصل على رمز التحقق عبر تطبيق التحقق"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "explanationMFAChoice": {
          
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التفعيل"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التفعيل"])}
            }
          }
        },
        "MFAChoice": {
          
        }
      },
      "ar-EG": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رسالة قصيرة"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تلقي رمز التحقق عبر رسالة نصية قصيرة"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["احصل على رمز التحقق عبر تطبيق التحقق"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قم بزيادة الأمان باستخدام المصادقة متعددة العوامل عند تسجيل الدخول."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التفعيل"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التفعيل"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مصادقة متعددة العوامل"])}
        }
      },
      "ar-LB": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تلقي رمز التحقق عبر رسالة نصية قصيرة"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["احصل على رمز التحقق عبر تطبيق التحقق"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق التوثيق"])}
        },
        "explanationMFAChoice": {
          
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التفعيل"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التفعيل"])}
            }
          }
        },
        "MFAChoice": {
          
        }
      },
      "ar-MA": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["استلام رمز التوثيق عبر الرسائل القصيرة"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["احصل على رمز التحقق عبر تطبيق التحقق"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق التوثيق"])}
        },
        "explanationMFAChoice": {
          
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التفعيل"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التفعيل"])}
            }
          }
        },
        "MFAChoice": {
          
        }
      },
      "ar-SA": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رسالة قصيرة"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تلقي رمز التحقق عبر رسالة نصية قصيرة"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["احصل على رمز التحقق عبر تطبيق التحقق"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قم بزيادة الأمان باستخدام المصادقة متعددة العوامل عند تسجيل الدخول."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مصادقة متعددة العوامل"])}
        }
      },
      "ar-SY": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تلقي رمز التحقق عبر رسالة نصية قصيرة"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["احصل على رمز التحقق عبر تطبيق التحقق"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "explanationMFAChoice": {
          
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التفعيل"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التفعيل"])}
            }
          }
        },
        "MFAChoice": {
          
        }
      },
      "ar-TN": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["استلام رمز التوثيق عبر الرسائل القصيرة"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["احصل على رمز التحقق عبر تطبيق التحقق"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق التوثيق"])}
        },
        "explanationMFAChoice": {
          
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التفعيل"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التفعيل"])}
            }
          }
        },
        "MFAChoice": {
          
        }
      },
      "bg-BG": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирано"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Получете код за удостоверяване чрез SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирано"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Получете код за удостоверяване през приложение за удостоверяване"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Приложение за удостоверяване"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Увеличете защитата с многофакторно удостоверяване при влизане."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирано"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирано"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Многофакторно удостоверяване"])}
        }
      },
      "bs-BA": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primite autentifikacijski kod putem SMS-a"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dobijte autentifikacioni kod putem autentifikacijske aplikacije"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacija za autentifikaciju"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Povećajte sigurnost pomoću višefaktorske autentifikacije prilikom prijavljivanja."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Višefaktorska autentifikacija"])}
        }
      },
      "cs-CZ": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivováno"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přijměte ověřovací kód prostřednictvím SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivováno"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Získejte ověřovací kód pomocí ověřovací aplikace"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentizační aplikace"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zvyšte zabezpečení pomocí vícefaktorového ověřování při přihlášení."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivováno"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivováno"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vícefaktorové ověřování"])}
        }
      },
      "da-DK": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveret"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modtag autentificeringskode via SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveret"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modtag autentificeringskode via autentificeringsapp"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentificeringsapp"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Forøg sikkerheden med multifaktorautentificering, når du logger ind."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveret"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveret"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multifaktorautentificering"])}
        }
      },
      "de-DE": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per SMS erhalten"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per Authentifizierungs-App erhalten."])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-App"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erhöhe die Sicherheit durch Multi-Faktor-Authentifizierung beim Login."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multi-Faktor-Authentifizierung"])}
        }
      },
      "de-AT": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per SMS erhalten"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per Authentifizierungs-App erhalten."])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-App"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erhöhe die Sicherheit durch Multi-Faktor-Authentifizierung beim Login."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multi-Faktor-Authentifizierung"])}
        }
      },
      "de-CH": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per SMS erhalten"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per Authentifizierungs-App erhalten."])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-App"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erhöhe die Sicherheit durch Multi-Faktor-Authentifizierung beim Login."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multi-Faktor-Authentifizierung"])}
        }
      },
      "de-LU": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per SMS erhalten"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per Authentifizierungs-App erhalten."])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-App"])}
        },
        "explanationMFAChoice": {
          
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          }
        },
        "MFAChoice": {
          
        }
      },
      "el-GR": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["γραπτό μήνυμα"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Λάβετε κωδικό επαλήθευσης μέσω SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Λάβετε κώδικα επαλήθευσης μέσω εφαρμογής επαλήθευσης"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εφαρμογή Επαλήθευσης"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αυξήστε την ασφάλεια με έλεγχο ταυτότητας πολλών παραγόντων κατά τη σύνδεση."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Έλεγχος ταυτότητας πολλών παραγόντων"])}
        }
      },
      "el-CY": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["γραπτό μήνυμα"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Λάβετε κωδικό επαλήθευσης μέσω SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Λάβετε κώδικα επαλήθευσης μέσω εφαρμογής επαλήθευσης"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εφαρμογή Επαλήθευσης"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αυξήστε την ασφάλεια με έλεγχο ταυτότητας πολλών παραγόντων κατά τη σύνδεση."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Έλεγχος ταυτότητας πολλών παραγόντων"])}
        }
      },
      "en-GB": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Receive Authentication Code via SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Receive authentication code via authentication app."])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication App"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Increase security with multi-factor authentication for login."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multi-Factor Authentication"])}
        }
      },
      "en-IE": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Receive Authentication Code via SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Receive authentication code via authentication app."])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication App"])}
        },
        "explanationMFAChoice": {
          
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
            }
          }
        },
        "MFAChoice": {
          
        }
      },
      "en-US": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Receive Authentication Code via SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Receive authentication code via authentication app."])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication App"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Increase security with multi-factor authentication for login."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multi-Factor Authentication"])}
        }
      },
      "es-ES": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activada"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recibir código de autenticación vía SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activada"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recibe código de autenticación a través de la aplicación de autenticación"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicación de autenticación"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aumente la seguridad de su cuenta con la autenticación multifactor para iniciar sesión."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activada"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activada"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autenticación multifactor"])}
        }
      },
      "et-EE": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeritud"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saage autentimiskood SMS-i teel"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeritud"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saa autentimiskoodi autentimisrakenduse kaudu"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimisrakendus"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suurendage sisselogimisel turvalisust mitme teguri autentimisega."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeritud"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeritud"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mitmeteguriline autentimine"])}
        }
      },
      "fi-FI": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoitu"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tekstiviesti"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vastaanota vahvistuskoodi SMS: n kautta"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoitu"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saa tunnistuskoodi tunnistussovelluksen kautta"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennussovellus"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paranna tietoturvaa monivaiheisella todennuksella sisäänkirjautumisen yhteydessä."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoitu"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoitu"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monivaiheinen todennus"])}
        }
      },
      "fr-BE": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recevez le code d'authentification par SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recevez le code d'authentification via l'application d'authentification"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Application d'authentification"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renforcez la sécurité grâce à l'authentification multifactorielle pour la connexion."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentification multi-facteurs"])}
        }
      },
      "fr-CH": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recevez le code d'authentification par SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recevez le code d'authentification via l'application d'authentification"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Application d'authentification"])}
        },
        "explanationMFAChoice": {
          
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          }
        },
        "MFAChoice": {
          
        }
      },
      "fr-FR": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recevez le code d'authentification par SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recevez le code d'authentification via l'application d'authentification"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Application d'authentification"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renforcez la sécurité grâce à l'authentification multifactorielle pour la connexion."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentification multi-facteurs"])}
        }
      },
      "fr-LU": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recevez le code d'authentification par SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recevez le code d'authentification via l'application d'authentification"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Application d'authentification"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renforcez la sécurité grâce à l'authentification multifactorielle pour la connexion."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentification multi-facteurs"])}
        }
      },
      "ga-IE": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaithe"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fáigh cód dearbhaithe trí SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaithe"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faigh cód fíordheimhnithe trí app fíordheimhnithe"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aip Authindála"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slándáil a mhéadú le fíordheimhniú ilfhachtóirí agus tú ag logáil isteach."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaithe"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaithe"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fíordheimhniú ilfhachtóirí"])}
        }
      },
      "he-IL": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מופעל"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["סמס"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קבל קוד אימות דרך SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מופעל"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קבל קוד אימות באמצעות אפליקציית אימות"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אפליקציית אימות"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדל את האבטחה באמצעות אימות רב-גורמי בעת כניסה."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מופעל"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מופעל"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אימות רב גורמים"])}
        }
      },
      "hi-IN": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["एसएमएस के माध्यम से प्रमाणीकरण कोड प्राप्त करें"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रामाणिकरण ऐप के माध्यम से प्रामाणिकरण कोड प्राप्त करें"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रमाणीकरण ऐप"])}
        },
        "explanationMFAChoice": {
          
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सक्रिय"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सक्रिय"])}
            }
          }
        },
        "MFAChoice": {
          
        }
      },
      "hr-HR": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviran"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primite autentifikacijski kod putem SMS-a"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviran"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primite autentifikacijski kod putem autentifikacijske aplikacije"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacija za autentifikaciju"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Povećajte sigurnost pomoću višefaktorske provjere autentičnosti prilikom prijave."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviran"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviran"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Višefaktorska autentifikacija"])}
        }
      },
      "hu-HU": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivált"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fogadja el az ellenőrző kódot SMS-ben"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivált"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szerezze be az hitelesítési kódot az hitelesítési alkalmazáson keresztül"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítő alkalmazás"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Növelje a biztonságot többfaktoros hitelesítéssel a bejelentkezéskor."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivált"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivált"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Többfaktoros hitelesítés"])}
        }
      },
      "it-CH": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ricevi il codice di autenticazione tramite SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ricevi il codice di autenticazione tramite l'app di autenticazione"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App di autenticazione"])}
        },
        "explanationMFAChoice": {
          
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivato"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivato"])}
            }
          }
        },
        "MFAChoice": {
          
        }
      },
      "it-IT": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivato"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ricevi il codice di autenticazione tramite SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivato"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ricevi il codice di autenticazione tramite l'app di autenticazione"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App di autenticazione"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aumenta la sicurezza con l'autenticazione a più fattori durante l'accesso."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivato"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivato"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autenticazione a più fattori"])}
        }
      },
      "ja-JP": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティブ化"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMSで認証コードを受け取る"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティブ化"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証アプリを経由して認証コードを受け取る"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証アプリ"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログイン時の多要素認証でセキュリティを強化。"])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティブ化"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティブ化"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["多要素認証"])}
        }
      },
      "ko-KR": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS를 통해 인증 코드 받기"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 앱을 통해 인증 코드를 받으세요"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 앱"])}
        },
        "explanationMFAChoice": {
          
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["활성화됨"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["활성화됨"])}
            }
          }
        },
        "MFAChoice": {
          
        }
      },
      "lt-LT": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinta"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trumpoji žinutė"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gauti autentifikacijos kodą per SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinta"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gaukite autentifikacijos kodą per autentifikacijos programą"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo programa"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Padidinkite saugumą naudodami dviejų veiksnių autentifikavimą, kai prisijungiate."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinta"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinta"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dviejų veiksnių autentifikavimas"])}
        }
      },
      "lv-LV": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēts"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Īsziņa"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saņemt autentifikācijas kodu caur SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēts"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saņemiet autentifikācijas kodu caur autentifikācijas lietotni"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas lietotne"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Palieliniet drošību, piesakoties, izmantojot daudzfaktoru autentifikāciju."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēts"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēts"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Daudzfaktoru autentifikācija"])}
        }
      },
      "mt-MT": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivat"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Irċievi kod ta' awtentikazzjoni permezz ta 'SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivat"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Irċievi kodiċi ta' awtentikazzjoni permezz ta' applikazzjoni ta' awtentikazzjoni"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App ta' awtentikazzjoni"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żid is-sigurtà b'awtentikazzjoni b'ħafna fatturi meta tidħol."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivat"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivat"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Awtentikazzjoni b'Ħafna Fatturi"])}
        }
      },
      "nb-NO": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Motta autentiseringskode via SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Motta autentiseringskode via autentiseringsapp"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringsapp"])}
        },
        "explanationMFAChoice": {
          
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivert"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivert"])}
            }
          }
        },
        "MFAChoice": {
          
        }
      },
      "nl-BE": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ontvang authenticatiecode via SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ontvang authenticatiecode via authenticatie-app"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatie-app"])}
        },
        "explanationMFAChoice": {
          
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geactiveerd"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geactiveerd"])}
            }
          }
        },
        "MFAChoice": {
          
        }
      },
      "nl-NL": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geactiveerd"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ontvang authenticatiecode via SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geactiveerd"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ontvang authenticatiecode via authenticatie-app"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatie-app"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verhoog de veiligheid met multifactorauthenticatie bij het aanmelden."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geactiveerd"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geactiveerd"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multi-Factor Authenticatie"])}
        }
      },
      "pl-PL": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywowano"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otrzymaj kod uwierzytelniający przez SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywowano"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odbierz kod uwierzytelniania za pośrednictwem aplikacji uwierzytelniania"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacja do uwierzytelniania"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zwiększ bezpieczeństwo dzięki uwierzytelnianiu wieloskładnikowemu podczas logowania."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywowano"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywowano"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uwierzytelnianie wieloskładnikowe"])}
        }
      },
      "pt-PT": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativado"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Receba o código de autenticação por SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativado"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Receba código de autenticação via aplicativo de autenticação"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicativo de autenticação"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aumente a segurança com a autenticação multifator ao efetuar o início de sessão."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativado"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativado"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autenticação multifator"])}
        }
      },
      "ro-RO": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activat"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primiți codul de autentificare prin SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activat"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primiți cod de autentificare prin aplicația de autentificare"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicație de autentificare"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Îmbunătățiti securitatea prin autentificarea cu mai mulți factori la conectare."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activat"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activat"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentificare cu mai mulți factori"])}
        }
      },
      "ru-RU": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировано"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Получить код аутентификации по SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировано"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Получите код аутентификации через приложение для аутентификации"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Приложение для аутентификации"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Повысьте безопасность с помощью многофакторной аутентификации при входе в систему."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировано"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировано"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Многофакторная аутентификация"])}
        }
      },
      "sk-SK": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivované"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prijmite overovací kód cez SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivované"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Získajte overovací kód cez overovaciu aplikáciu"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikačná aplikácia"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zvýšte zabezpečenie pomocou viacfaktorového overenia pri prihlasovaní."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivované"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivované"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viacfaktorové overenie"])}
        }
      },
      "sl-SI": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prejmite avtentikacijsko kodo prek SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prejmite avtentikacijsko kodo preko avtentikacijske aplikacije"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacija za avtentikacijo"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izboljšajte varnost z večkratnim preverjanjem pristnosti ob prijavi."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Večkratno preverjanje pristnosti"])}
        }
      },
      "sv-SE": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiverad"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ta emot autentiseringskod via SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiverad"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ta emot autentiseringskod via autentiseringsapp"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringsapp"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Öka säkerheten med autentisering med flera faktorer när du loggar in."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiverad"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiverad"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multifaktorautentisering"])}
        }
      },
      "th-TH": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["รับรหัสยืนยันผ่าน SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["รับรหัสการยืนยันตัวตนผ่านแอปการยืนยันตัวตน"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["แอปพลิเคชันการรับรองความถูกต้อง"])}
        },
        "explanationMFAChoice": {
          
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["เปิดใช้งานแล้ว"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["เปิดใช้งานแล้ว"])}
            }
          }
        },
        "MFAChoice": {
          
        }
      },
      "tr-CY": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS ile doğrulama kodu alın"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama uygulaması aracılığıyla doğrulama kodunu alın"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik Doğrulama Uygulaması"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oturum açarken çok faktörlü kimlik doğrulama ile güvenliği artırın."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çok faktörlü kimlik doğrulama"])}
        }
      },
      "tr-TR": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS ile doğrulama kodu alın"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama uygulaması aracılığıyla doğrulama kodunu alın"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik Doğrulama Uygulaması"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oturum açarken çok faktörlü kimlik doğrulama ile güvenliği artırın."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çok faktörlü kimlik doğrulama"])}
        }
      },
      "uk-UA": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активовано"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отримайте код автентифікації через SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активовано"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отримайте код автентифікації через додаток для автентифікації"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Додаток для автентифікації"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erhöhe die Sicherheit durch Multi-Faktor-Authentifizierung beim Login."])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активовано"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активовано"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Багатофакторна автентифікація"])}
        }
      },
      "vi-VN": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nhận mã xác thực qua SMS"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nhận mã xác thực qua ứng dụng xác thực"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ứng dụng Xác thực"])}
        },
        "explanationMFAChoice": {
          
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Đã kích hoạt"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Đã kích hoạt"])}
            }
          }
        },
        "MFAChoice": {
          
        }
      },
      "zh-CN": {
        "SMSMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已激活"])}
            }
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["短信"])},
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通过短信接收认证码"])}
          }
        },
        "authenticatorMFA": {
          "feedforward": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已激活"])}
            }
          },
          "description": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通过认证应用获取认证代码"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["认证应用"])}
        },
        "explanationMFAChoice": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登录时通过多重身份验证提高安全性。"])}
        },
        "feedforward": {
          "SMSMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已激活"])}
            }
          },
          "authenticatorMFA": {
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已激活"])}
            }
          }
        },
        "MFAChoice": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["多重身份验证"])}
        }
      }
    }
  })
}
